const removeKeys = [
    // these are meta fields kept in the form for ProgressForm navigation purposes
    // they need to be removed before submission to backend
    'id_number_type',
    'inReview',
    'url',
    'new_vessel',
    'vessel_type',
    'vessel_name',
    'undefined',
];

const sanitize = input => {
    if (typeof input !== 'object' || input === null || input === undefined) {
        return input;
    }
    return Object.keys(input).reduce((output, key) => {
        if (removeKeys.includes(key) || key.match(/^_/)) {
            return output;
        }
        const value = input[key];
        if (Array.isArray(value)) {
            return {
                ...output,
                [key]: value.map(item => sanitize(item)),
            };
        } else if (typeof value === 'object') {
            return {
                ...output,
                [key]: sanitize(value),
            };
        }
        return {
            ...output,
            [key]: value,
        };
    }, {});
};

const sanitizeData = data => {
    // Remove keys starting with '_' which are BE calculated OR
    // FE fields that the backend doesn't care about
    const {user_document_post_response, ...state} = sanitize(data);

    return {
        ...state,
        user_document_id: user_document_post_response?.user_document?.id,
    };
};

export default sanitizeData;
export {sanitizeData};
